import List from "./List";
import Creator from "./Creator";
const Components = { List, Creator };

export default Components;
